<template>
  <div
    class="dashboard-stat-card group relative bg-white dark:bg-[#111C30] p-4 sm:p-5 rounded-2xl border border-slate-200/80 dark:border-[#1E293B] shadow-[0_1px_3px_rgba(0,0,0,0.03)] hover:shadow-lg hover:shadow-indigo-500/5 transition-all duration-200 select-none cursor-default overflow-hidden"
  >
    <!-- Top Row: Icon + Mini Status Dot -->
    <div class="flex items-center justify-between gap-3 mb-3">
      <div
        :class="[
          'w-10 h-10 sm:w-11 sm:h-11 rounded-xl flex items-center justify-center transition-transform duration-200 group-hover:scale-110 shadow-xs shrink-0',
          bgColorClass,
        ]"
      >
        <component
          :is="icon"
          class="w-5 h-5 transition-transform duration-200"
          :class="iconColorClass"
        />
      </div>

      <span
        class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold bg-slate-50 dark:bg-slate-800/80 text-slate-500 dark:text-slate-400 border border-slate-200/60 dark:border-slate-700/60"
      >
        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
        <span>Active</span>
      </span>
    </div>

    <!-- Metric Value & Label Stack -->
    <div>
      <p class="text-xs font-semibold text-slate-500 dark:text-slate-400 tracking-wider uppercase truncate">
        {{ label }}
      </p>
      <div class="flex items-baseline gap-2 mt-1">
        <h3 class="text-2xl sm:text-3xl font-black text-slate-900 dark:text-white tracking-tight truncate">
          {{ value }}
        </h3>
      </div>
    </div>

    <!-- Subtle Accent Underline on Hover -->
    <div
      class="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-indigo-500/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
    ></div>
  </div>
</template>

<script>
  export default {
    name: "DashboardCards",
    props: {
      icon: {
        type: [Object, Function],
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      value: {
        type: [String, Number],
        required: true,
      },
      bgColor: {
        type: String,
        default: "bg-indigo-50",
      },
      iconColor: {
        type: String,
        default: "text-indigo-600",
      },
    },
    computed: {
      bgColorClass() {
        // Map common bg colors to modern subtle tints
        const bg = this.bgColor || "";
        if (bg.includes("blue")) return "bg-blue-50 dark:bg-blue-950/50 text-blue-600 dark:text-blue-400 border border-blue-100 dark:border-blue-900/40";
        if (bg.includes("green")) return "bg-emerald-50 dark:bg-emerald-950/50 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900/40";
        if (bg.includes("purple")) return "bg-indigo-50 dark:bg-indigo-950/50 text-indigo-600 dark:text-indigo-400 border border-indigo-100 dark:border-indigo-900/40";
        if (bg.includes("orange")) return "bg-amber-50 dark:bg-amber-950/50 text-amber-600 dark:text-amber-400 border border-amber-100 dark:border-amber-900/40";
        return "bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300";
      },
      iconColorClass() {
        const c = this.iconColor || "";
        if (c.includes("blue")) return "text-blue-600 dark:text-blue-400";
        if (c.includes("green")) return "text-emerald-600 dark:text-emerald-400";
        if (c.includes("purple")) return "text-indigo-600 dark:text-indigo-400";
        if (c.includes("orange")) return "text-amber-600 dark:text-amber-400";
        return "text-slate-600 dark:text-slate-300";
      },
    },
  };
</script>

<style scoped>
  .dashboard-stat-card {
    transition: transform 0.22s cubic-bezier(0.16, 1, 0.3, 1),
                box-shadow 0.22s cubic-bezier(0.16, 1, 0.3, 1),
                border-color 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  }
  .dashboard-stat-card:hover {
    transform: translateY(-3px);
    border-color: rgba(99, 102, 241, 0.35);
  }
</style>
